import { Divider, List, ListItem } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { Coin } from "../shop/Coin";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";

export default observer(function OrderOverview(props: {price: number}) {
    const {price} = {...props};
    const remainingBalance = creditBalanceStorage.balance - price;

    return (
        <List sx={{listStyle: 'none', p: 0}}>
            <ListItem disableGutters secondaryAction={<Coin amount={creditBalanceStorage.balance} text=" "/>}>{translationService.translate("general.apps.priceMenu.currentBalance")}</ListItem>
            <ListItem disableGutters secondaryAction={<Coin amount={price} text=" "/>}>{translationService.translate("general.apps.priceMenu.appPrice")}</ListItem>
            <Divider sx={{borderBottomWidth: '5px' }} />
            <ListItem disableGutters secondaryAction={<Coin amount={remainingBalance} text=" "/>}>{translationService.translate("general.apps.priceMenu.remainingBalance")}</ListItem>
        </List>   
    )
})